function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5.0556641mm",
    height: "7.5899162mm",
    viewBox: "0 0 5.0556641 7.5899162",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.512859,-58.170486)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 12.90446,65.51033 q -0.07324,-0.141601 -0.107421,-0.268554 -0.03418,-0.126954 -0.03418,-0.239258 0,-0.507813 1.020508,-1.25 0.283203,-0.205078 0.439453,-0.322266 1.127929,-0.854492 1.645508,-1.547851 0.522461,-0.69336 0.522461,-1.342774 0,-0.571289 -0.385743,-0.922851 -0.385742,-0.356446 -1.015625,-0.356446 -0.498047,0 -0.854492,0.244141 -0.356445,0.239258 -0.625,0.756836 -0.205078,-0.131836 -0.307617,-0.288086 -0.102539,-0.15625 -0.102539,-0.332031 0,-0.50293 0.546875,-0.859375 0.551758,-0.361329 1.37207,-0.361329 1.025391,0 1.660156,0.57129 0.639649,0.571289 0.639649,1.479492 0,0.932617 -0.844727,1.933593 -0.844726,1.000977 -2.680664,2.236329 0.136719,0.0049 0.371094,0.0098 0.419922,0.0098 0.546875,0.0098 0.952148,0 1.552734,-0.08301 0.600586,-0.08789 0.908204,-0.263672 0.06348,0.166016 0.09277,0.317383 0.03418,0.146484 0.03418,0.27832 0,0.322266 -0.205078,0.454102 -0.205079,0.126953 -0.751954,0.126953 -0.415039,0 -1.166992,-0.02441 -0.74707,-0.02441 -1.083984,-0.02441 -0.341797,0 -0.634766,0.01953 -0.292969,0.01465 -0.551758,0.04883 z",
    style: {
      fontSize: 10,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit2);
export default __webpack_public_path__ + "static/media/digit-2.1072a6f99aead466801c7fb976f0c8db.svg";
export { ForwardRef as ReactComponent };